import axios from '@/utils/request'
import cache from '@/utils/cache'
import qs from 'qs'

function login(loginForm: any) {
  return new Promise((resolve, reject) => {
      let username=loginForm.username;
      let password=loginForm.password;
    axios({
      method: 'post',
      url: '/user/signin',
      params: {username:username,password:password},
      headers: {clienttype: 'PC'},
      loadingOptions: {
        text: '努力登录中......',
        background: 'rgba(0, 0, 0, 0.7)'
      }
    } as any)
      .then(response => {
        // 清除缓存
        cache.clear()
        let user: any = {}
        user.name = response.data.xm
        user.username = response.data.username
        user.token = response.data.access_token
        user.organization = response.data.organization
        user.userId = response.data.id
        user.mainPage = response.data.mainPage
        user.zw = response.data.zw
        user.type = response.data.type
        user.dataQueryOrganizationPrefix = response.data.dataQueryOrganizationPrefix

        user.roles = response.data.authorities.map((item: any) => {
          return item.authority
        })
        
        user.zzdyqcmc = response.data.ZZDYQCMC
        user.zzdyqc = response.data.zzdyqc
        user.customerId = response.data.customerId
        user.islogin=response.data.islogin
        response.data = user
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function caLogin(encryptedData: any) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: '/user/calogin',
      data: {
        encryptedData: encryptedData
      },
      loadingOptions: {
        text: '努力登录中......',
        background: 'rgba(0, 0, 0, 0.7)'
      }
    } as any)
      .then(response => {
        let user: any = {}
        user.name = response.data.name
        user.username = response.data.username
        user.token = response.data.access_token
        user.organization = response.data.organization
        user.userId = response.data.userId
        user.mainPage = response.data.mainPage
        user.dataQueryOrganizationPrefix = response.data.dataQueryOrganizationPrefix
          user.zzdyqc = response.data.zzdyqc
        user.roles = response.data.authorities.map((item: any) => {
          return item.authority
        })
        response.data = user
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function logout() {
  axios({
    method: 'get',
    url: '/user/logout'
  } as any)
    .then(response => {
      console.log('退出成功')
    })
    .catch(error => {
      console.log('退出失败')
    })
}

// 获取用户信息
function getUserInfo() {
  return new Promise((resolve, reject) => {
    axios
      .get('/user/userInfo', {
        loadingOptions: {
          text: '数据加载中......',
          background: 'rgba(0, 0, 0, 0.7)'
        }
      } as any)
      .then(response => {
        let user: any = {}
        user.username = response.data.username
        user.name = response.data.name
        user.organization = response.data.organization
        user.dataQueryOrganizationPrefix = response.data.dataQueryOrganizationPrefix
        user.userId = response.data.userId
        user.mainPage = response.data.mainPage
        user.idcard = response.data.idcard
        user.zw = response.data.zw
        user.zzdyqc = response.data.zzdyqc
        user.type = response.data.type
        user.customerId = response.data.customerId
        // user.roles = response.data.authorities.map((item: any) => {
        //   return item.authority
        // })
        var resource = response.data.resource
        //
        filterResource(resource)
        user.resource = resource
        response.data = user
        // store.commit('updateUser', user)
        resolve(response as any)
      })
      .catch(error => {
        reject(error as any)
      })
  })
}

//将菜单过滤为适配menu组件的格式
function filterResource(resources: Array<any>) {
  if (!resources) {
    return null
  }
  resources.forEach(element => {
    element.children = element.childResourceList
    if (element.href && !element.href.startsWith('/')) {
      element.href = '/' + element.href
    }
    element.path = element.href
    element.title = element.name
    element.icon = element.resourceIcon

    // if (element.children && element.children.length === 0) {
    //   var indexs: any = []
    //   element.children.forEach((item: any, index: any) => { })
    //   if (indexs.length === element.children.length) {
    //     delete element.children
    //   } else {
    //     indexs.forEach((i: any) => {
    //       delete element.children[i]
    //     })
    //   }
    // }
    filterResource(element.children)
  })
}

function isAuth(key:String) {
    return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}
function setQueryConfig(queryConfig){
    var _str = "";
    for(var o in queryConfig){
        _str += o + "=" + queryConfig[o] + "&";
    }
    var _str = _str.substring(0, _str.length-1);
    return _str;
}
const CONST_ZN_BM= '5b94d0f473c308e0c3d01686e8ece0ba'
export { getUserInfo, login, caLogin, logout,isAuth,CONST_ZN_BM,setQueryConfig}
